import { motion } from "framer-motion";
import { CheckCircle2, ArrowUpRight } from "lucide-react";
import { CASE_STUDIES } from "@/lib/site";
import { Reveal } from "./Reveal";

export const SuccessStories = () => {
  return (
    <section id="success" data-testid="success-stories" className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <Reveal>
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-brand mb-4">05 — Success Stories</p>
          <h2 className="font-display font-extrabold text-navy tracking-tight text-4xl md:text-5xl max-w-2xl leading-[1.05]">
            Real MSMEs. Real funding secured.
          </h2>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-6">
          {CASE_STUDIES.map((c, i) => (
            <motion.div
              key={c.type}
              initial={{ opacity: 0, y: 26 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
              data-testid={`case-study-${i}`}
              className="group rounded-3xl p-8 bg-surface border border-black/5 hover:-translate-y-1 transition-transform duration-300"
            >
              <div className="flex items-center justify-between">
                <span className="inline-flex items-center gap-1.5 text-xs font-semibold text-emerald bg-emerald/10 px-3 py-1 rounded-full">
                  <CheckCircle2 className="w-3.5 h-3.5" /> {c.tag}
                </span>
                <ArrowUpRight className="w-5 h-5 text-ink/30 group-hover:text-brand transition-colors" />
              </div>
              <div className="mt-8 font-display font-black text-4xl text-navy">{c.amount}</div>
              <p className="mt-2 text-sm font-semibold text-brand">{c.product}</p>
              <p className="mt-5 pt-5 border-t border-black/5 text-navy font-display font-bold text-lg">{c.type}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
